"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Login;
var _react = _interopRequireWildcard(require("react"));
var _awsAmplify = require("aws-amplify");
var _reactRouterDom = require("react-router-dom");
var _LoginScreenComponent = _interopRequireDefault(require("../components/LoginScreenComponent"));
var _helper = require("../common_features/utility/helper");
var _reactRedux = require("react-redux");
var _loginReducer = require("../common_features/redux/reducers/loginReducer");
var _index = _interopRequireDefault(require("../common_features/assets/index"));
var _RoutePath = _interopRequireDefault(require("../RoutePath"));
var _Services = require("../common_features/utility/Services");
var _index2 = _interopRequireDefault(require("../common_features/assets/images/index"));
var _storesReducer = require("../common_features/redux/reducers/storesReducer");
var _ToastContainer = require("@ccw-pwa-ui/ToastContainer");
require("./toast.css");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function Login(props) {
  const [username, setUsername] = (0, _react.useState)(null);
  const [password, setPassword] = (0, _react.useState)(null);
  const [isLoading, setIsLoading] = (0, _react.useState)(false);
  const [errorMessage, SetErrorMessage] = (0, _react.useState)(false);
  const [isEmailTouch, setIsEmailTouch] = (0, _react.useState)(false);
  const navigate = (0, _reactRouterDom.useNavigate)();
  const dispatch = (0, _reactRedux.useDispatch)();
  function checkDisabled() {
    return username && password && password.length > 7 && (0, _helper.validateEmail)(username) || false;
  }
  const handleEmailBlur = () => {
    setIsEmailTouch(true);
  };
  const handleUserInfo = async user => {
    var _user$challengeParam, _user$challengeParam$, _user$attributes;
    let dataKey = "";
    if (user !== null && user !== void 0 && (_user$challengeParam = user.challengeParam) !== null && _user$challengeParam !== void 0 && (_user$challengeParam$ = _user$challengeParam.userAttributes) !== null && _user$challengeParam$ !== void 0 && _user$challengeParam$.email || user !== null && user !== void 0 && (_user$attributes = user.attributes) !== null && _user$attributes !== void 0 && _user$attributes.email) {
      var _user$challengeParam2, _user$challengeParam3, _user$attributes2;
      dataKey = (user === null || user === void 0 ? void 0 : (_user$challengeParam2 = user.challengeParam) === null || _user$challengeParam2 === void 0 ? void 0 : (_user$challengeParam3 = _user$challengeParam2.userAttributes) === null || _user$challengeParam3 === void 0 ? void 0 : _user$challengeParam3.email) || (user === null || user === void 0 ? void 0 : (_user$attributes2 = user.attributes) === null || _user$attributes2 === void 0 ? void 0 : _user$attributes2.email);
    } else {
      dataKey = username;
    }
    if (user.challengeName != 'NEW_PASSWORD_REQUIRED') {
      getCurrentRole(user);
    }
    dispatch((0, _loginReducer.loginUserInfo)({
      email: dataKey.toLowerCase(),
      password,
      challengeName: user.challengeName,
      poolId: user.pool.userPoolId
    }));
    if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
      navigate(_RoutePath.default.forceChangePassword.useLink);
    } else if (+user.attributes["custom:onboarding_flag"] === 0) {
      navigate(_RoutePath.default.createProfile.path);
    } else if (+user.attributes["custom:onboarding_flag"] === 1) {
      navigate(_RoutePath.default.NotificationPreferencesOnboard.useLink);
    } else if (user.attributes.email_verified === false) {
      navigate(_RoutePath.default.emailUpdate.path);
    } else {
      navigate(_RoutePath.default.admin.path);
      dispatch((0, _storesReducer.clearStore)());
    }
    setIsLoading(false);
  };
  const signInUser = () => {
    try {
      if (username && (0, _helper.validateEmail)(username)) {
        setIsLoading(true);
        _awsAmplify.Auth.signIn(username.toLowerCase().trim(), password).then(handleUserInfo).catch(error => {
          if (error.message.indexOf("code") > -1) {
            const errResp = JSON.parse(error.message.substring(error.message.indexOf('{'), error.message.indexOf('}') + 1));
            _ToastContainer.CustomToast.error(errResp.message);
          }
          setIsLoading(false);
          SetErrorMessage(true);
        });
      }
    } catch (error) {
      alert(error);
    }
  };
  const getCurrentRole = user => {
    (0, _Services.getRoles)().then(res => {
      if (res.success) {
        dispatch((0, _loginReducer.SetUserRoles)(res.data));
      }
    });
    let userType = user.signInUserSession.accessToken.payload["cognito:groups"][0];
    let roleId = (0, _helper.getUserTypeFromGroup)(userType);
    dispatch((0, _loginReducer.loginUserInfo)({
      email: user.attributes.email,
      password,
      challengeName: user.challengeName,
      poolId: user.pool.userPoolId,
      username: user.username,
      userType: roleId
    }));
  };
  (0, _react.useEffect)(() => {
    _awsAmplify.Auth.currentAuthenticatedUser().then().catch(error => {
      console.log('isCurrentAuthenticatedUser- ', error);
    });
    return "";
  }, []);
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_LoginScreenComponent.default, {
    headerImage: _index.default.pentairLogo.default,
    forgotText: "Forgot Password",
    headerText: "Welcome to ServiceConnect!",
    headerSubText: "Sign in to go to your account.",
    emailText: "Email",
    emailPlaceholder: "Enter email",
    passwordText: "Password",
    passwordSubText: "Enter password",
    signinText: "Sign In",
    isLoading: isLoading,
    onClickSignInButton: signInUser,
    onKeyPressHandler: () => {},
    email: username,
    onEmailChange: e => (0, _helper.onChangeHandler)(e, setUsername),
    password: password,
    onPasswordChange: e => (0, _helper.onChangeHandler)(e, setPassword),
    forgotPasswordUrl: "/ForgotPassword",
    isSignInDisabled: checkDisabled(),
    errorMessage: errorMessage,
    isEmailValid: (0, _helper.validateEmail)(username),
    isEmailTouch: isEmailTouch,
    handleEmailBlur: handleEmailBlur,
    errorImage: _index2.default.warning.default
  }));
}